/* eslint-disable react/no-array-index-key */
import React, { ReactNode, useEffect, useState } from 'react'

import { Data } from 'state/dashboard/types'
import { trackEvent } from 'utils/googleAnalytics'

import AllStarLogo from '../Images/AllStarLogo'
import MVPLogo from '../Images/MVPLogo'
import ProLogo from '../Images/ProLogo'
import Star from '../Images/Star'
import { DashboardItemProps } from '../types'
import { BadgeList, PerksContainer } from './Perks.styled'

const LEAGUE_BADGES: { [key: string]: ReactNode } = {
    'all-star': <AllStarLogo />,
    mvp: <MVPLogo />,
    pro: <ProLogo />,
}

function Perks({ componentStyle, data, dealershipName }: DashboardItemProps) {
    const [interaction, setInteraction] = useState(false)

    function goToDetails() {
        window.open('https://www.octanepreferred.com/', '_blank', 'noopener')
        trackEvent('Loyalty Dashboard', 'Clicked Octane Preferred Details')
    }

    function trackInteraction() {
        if (interaction) return

        trackEvent(
            'Loyalty Dashboard',
            `Benefits Panel Interaction`,
            'dealership',
            dealershipName,
        )

        setInteraction(true)
    }

    useEffect(() => {
        const root: HTMLBodyElement | null =
            window.document.querySelector(':root')

        if (data.leagueBadge === 'mvp')
            root?.style.setProperty('--dashboard-badge-color', '#ffbe5e')

        if (data.leagueBadge === 'all-star')
            root?.style.setProperty('--dashboard-badge-color', '#33e1ed')

        if (data.leagueBadge === 'pro')
            root?.style.setProperty('--dashboard-badge-color', '#EDF67D')
    }, [data])

    return (
        <PerksContainer componentStyle={componentStyle || ''}>
            <div data-testid="perks-container" onMouseEnter={trackInteraction}>
                <header>{data.badgeTitle}</header>
                <BadgeList>
                    <figure>{LEAGUE_BADGES[`${data.leagueBadge}`]}</figure>
                    <ul>
                        {data.perks.map((perk: Data, index: number) => (
                            <li key={index}>
                                <Star />
                                <strong>{`${perk.title}`}</strong>{' '}
                                {`${perk.description}`}
                            </li>
                        ))}
                    </ul>
                </BadgeList>
            </div>
            <footer>
                <p>And so much more</p>
                <button onClick={goToDetails} type="button">
                    Learn more about <br />
                    <b>Octane Preferred&#8482;</b>
                </button>
            </footer>
        </PerksContainer>
    )
}

export default Perks
